import { OrderStyleType, TicketFormType } from 'data/types'
import { actionTypes as AT, FormAction } from 'redux-form'
import { SideType } from 'scenes/MarketData/types'
import webSocket from 'services/api/webSocket'

import ticket from './selectors'

const getTif = (currentTif, type: OrderStyleType) => {
  const tifs = ticket.tifByType[type]
  const tif = tifs.find(({ value }) => value === currentTif)

  if (tif) {
    return tif.value
  }

  return webSocket.order.tif.GTC
}

type TicketState = {
  readonly values: TicketFormType
}

const ticketForm = (state: TicketState, action: FormAction) => {
  switch (action.type) {
    case AT.CHANGE: {
      if (action.meta.field === 'type') {
        const type: OrderStyleType = action.payload
        const limitPrice =
          type === webSocket.order.type.LIMIT || type === webSocket.order.type.STOP_LIMIT
            ? state.values.limitPrice
            : undefined

        return {
          ...state,
          values: {
            ...state.values,
            limitPrice,
            liquidity: undefined,
            tif: getTif(state.values.tif, type),
            type
          }
        }
      }

      if (action.meta.field === 'side') {
        const side: SideType = action.payload
        const type = ticket.typesBySide[side].find(({ value }) => value === state.values.type)
          ? state.values.type
          : webSocket.order.type.LIMIT

        return {
          ...state,
          values: {
            ...state.values,
            side,
            tif: getTif(state.values.tif, type),
            type
          }
        }
      }

      return state
    }

    default: {
      return state
    }
  }
}

export default ticketForm
